<template>
  <div class="agreement">
    <p v-html="agreement.content"></p>
  </div>
</template>

<script>
export default {
  name: "agreement",
  components: { },
  data() {
    return {
      agreement:[],
      type:''
    }
  },
  created() {
    if(this.$route.query.type == 0){
      this.type = 99;
    }else{
      this.type = this.$route.query.type;
    }
    
    this.init();
  },
  methods: {
    init(){
      this.axios({
        url: this.api.tech.get_agreement,
        data: {type:this.type}
      }).then(res => {
        if (res.error === 0) {
          this.agreement = res.agreement;
        }else{
          this.$toast(res.error);
        }
      });
    },
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/agreement.vue